import { lazy } from "react";

export const ViewAdminPricePage = lazy(() => {
  const __import = import("@/pages/Admin/View/ViewAdminPricePage");
  __import.finally(() => {});
  return __import;
});

export const AddAdminWireframeTablePage = lazy(() => {
  const __import = import("@/pages/Admin/Add/AddAdminWireframeTablePage");
  __import.finally(() => {});
  return __import;
});
export const EditAdminPlanPage = lazy(() => {
  const __import = import("@/pages/Admin/Edit/EditAdminPlanPage");
  __import.finally(() => {});
  return __import;
});
export const ListAdminPricePage = lazy(() => {
  const __import = import("@/pages/Admin/List/ListAdminPricePage");
  __import.finally(() => {});
  return __import;
});

export const ViewAdminWireframeTablePage = lazy(() => {
  const __import = import("@/pages/Admin/View/ViewAdminWireframeTablePage");
  __import.finally(() => {});
  return __import;
});

export const ListAdminWireframeTablePage = lazy(() => {
  const __import = import("@/pages/Admin/List/ListAdminWireframeTablePage");
  __import.finally(() => {});
  return __import;
});
export const ListAdminPlansPage = lazy(() => {
  const __import = import("@/pages/Admin/List/ListAdminPlansPage");
  __import.finally(() => {});
  return __import;
});
export const ViewAdminUserTable = lazy(() => {
  const __import = import("@/pages/Admin/View/ViewAdminUserTable");
  __import.finally(() => {});
  return __import;
});
export const EditAdminUserTablePage = lazy(() => {
  const __import = import("@/pages/Admin/Edit/EditAdminUserTablePage");
  __import.finally(() => {});
  return __import;
});
export const ListAdminUserPage = lazy(() => {
  const __import = import("@/pages/Admin/List/ListAdminUserPage");
  __import.finally(() => {});
  return __import;
});
export const AdminForgotPage = lazy(() => {
  const __import = import("@/pages/Admin/Auth/AdminForgotPage");
  __import.finally(() => {});
  return __import;
});

export const AdminLoginPage = lazy(() => {
  const __import = import("@/pages/Admin/Auth/AdminLoginPage");
  __import.finally(() => {});
  return __import;
});

export const AdminProfilePage = lazy(() => {
  const __import = import("@/pages/Admin/Auth/AdminProfilePage");
  __import.finally(() => {});
  return __import;
});

export const AdminResetPage = lazy(() => {
  const __import = import("@/pages/Admin/Auth/AdminResetPage");
  __import.finally(() => {});
  return __import;
});

export const AdminSignUpPage = lazy(() => {
  const __import = import("@/pages/Admin/Auth/AdminSignUpPage");
  __import.finally(() => {});
  return __import;
});

export const LandingPage = lazy(() => {
  const __import = import("@/pages/Admin/View/LandingPage");
  __import.finally(() => {});
  return __import;
});
export const HomePage = lazy(() => {
  const __import = import("@/pages/Marketing/Home");
  __import.finally(() => {});
  return __import;
});
export const PricePage = lazy(() => {
  const __import = import("@/pages/Marketing/Pricing");
  __import.finally(() => {});
  return __import;
});
export const ContactUs = lazy(() => {
  const __import = import("@/pages/Marketing/ContactUs");
  __import.finally(() => {});
  return __import;
});

export const CustomerLogin = lazy(() => {
  const __import = import("@/pages/Marketing/Login");
  __import.finally(() => {});
  return __import;
});
export const CustomerReset = lazy(() => {
  const __import = import("@/pages/Marketing/Reset");
  __import.finally(() => {});
  return __import;
});
export const CustomerOauth = lazy(() => {
  const __import = import("@/pages/Customer/Auth/Oauth");
  __import.finally(() => {});
  return __import;
});
export const CustomerRegister = lazy(() => {
  const __import = import("@/pages/Marketing/GetStarted");
  __import.finally(() => {});
  return __import;
});

export const UserProfile = lazy(() => {
  const __import = import("@/pages/Customer/Auth/CustomerProfilePage");
  __import.finally(() => {});
  return __import;
});
export const CustomerDashboard = lazy(() => {
  const __import = import("@/pages/Customer/Dashboard");
  __import.finally(() => {});
  return __import;
});
export const CustomerReports = lazy(() => {
  const __import = import("@/pages/Customer/Analysis/AllReports");
  __import.finally(() => {});
  return __import;
});
export const CustomerReport = lazy(() => {
  const __import = import("@/pages/Customer/Analysis/Report");
  __import.finally(() => {});
  return __import;
});
export const CustomerWebsiteAnalysis = lazy(() => {
  const __import = import("@/pages/Customer/Analysis/StartWebsiteAnalysis");
  __import.finally(() => {});
  return __import;
});
export const CustomerStripePayment = lazy(() => {
  const __import = import("@/pages/Customer/StripePayment");
  __import.finally(() => {});
  return __import;
});
export const CustomerSettings = lazy(() => {
  const __import = import("@/pages/Customer/Settings");
  __import.finally(() => {});
  return __import;
});

export const Success = lazy(() => {
  const __import = import("@/pages/Auth/Success");
  __import.finally(() => {});
  return __import;
});

export const AddAdminPlanPage = lazy(() => {
  const __import = import("@/pages/Admin/Add/AddAdminPlanPage");
  __import.finally(() => {});
  return __import;
});

export const AddAdminPricePage = lazy(() => {
  const __import = import("@/pages/Admin/Add/AddAdminPricePage");
  __import.finally(() => {});
  return __import;
});

export const ViewAdminPlanPage = lazy(() => {
  const __import = import("@/pages/Admin/View/ViewAdminPlanPage");
  __import.finally(() => {});
  return __import;
});

export const ViewAdminPriceDetailPage = lazy(() => {
  const __import = import("@/pages/Admin/View/ViewAdminPriceDetailPage");
  __import.finally(() => {});
  return __import;
});
